<template>
    <div>
        <BCardGroup deck>
            <BCard>
                <h3 class="text-center">V 2.1.3</h3>
                <p class="text-center"><small>ultima actualización: 04/03/2023</small></p>
            </BCard>
            <BCard>
                <h3 class="text-center mb-2"><FeatherIcon icon="RefreshCwIcon" size="40" /></h3>
                <BButton variant="primary" class="text-center col-6 m-auto" block wid>Buscar actualizaciones</BButton>
            </BCard>
        </BCardGroup>
      <BCard>
        <BRow>
            <BCol cols="12">
                <h2>Changelog</h2>
                <p>Versión 2.1.3 del Panel de Gestión de Escuelas de Enseñanza (04/03/2023):<br>
                    <br>
                    <br>
                    <b>Características Nuevas:</b><br>
                    Creación de cuentas de usuario para estudiantes y padres de familia.<br>
                    Creación de una sección de calendario para programar eventos escolares y fechas importantes.<br>
                    Implementación de un sistema de notificaciones para mantener a los estudiantes y padres actualizados sobre las actividades escolares y noticias relevantes.<br>
                    Creación de una sección de notas donde los profesores pueden ingresar las calificaciones de los estudiantes y los padres pueden verlas.<br>
                    Incorporación de una sección de tareas donde los profesores pueden asignar tareas y los estudiantes pueden entregarlas.<br>
                    <br>
                    <b>Mejoras y cambios:</b><br>
                    Rediseño de la interfaz de usuario para hacerla más fácil de usar y accesible.<br>
                    Mejora de la seguridad del sistema mediante la implementación de medidas de autenticación y autorización adicionales.<br>
                    Corrección de errores y optimización de la velocidad y estabilidad del sistema.<br>
                    Implementación de un sistema de copias de seguridad y recuperación de datos para proteger los datos de los usuarios en caso de un fallo del sistema.<br>
                    Mejora del rendimiento del sistema al reducir la carga en la base de datos.<br>
                    <br>
                    <b>Notas:</b><br>
                    Esta es la primera versión pública del Panel de Gestión de Escuelas de Enseñanza.<br>
                    Agradecemos cualquier comentario o sugerencia que nos ayude a mejorar el sistema.<br>
                    Nos comprometemos a seguir mejorando el Panel de Gestión de Escuelas de Enseñanza y agregar nuevas funcionalidades en futuras versiones.<br>
                </p>
            </BCol>
        </BRow>
      </BCard>
    </div>
</template>

<script>
import { BButton, BCard, BCardGroup, BCol, BRow } from 'bootstrap-vue';

export default {
    components: { BCard, BRow, BButton, BCol, BCardGroup },
    setup(){

    }
}
</script>

<style>

</style>
